import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Title from '../../GoBackShop';
import open from '../../../static/images/p_open.png';
import user from '../../../static/images/user.png';
import home from '../../../store/index'
import './index.css'

@observer
class PersonDetail extends Component {
    componentDidMount() {
        home.PeoplefindOne()
    }
    render() {
        return (
            <div className='PersonDetail'>
                <Title />
                <div className='p_detail_cnt'>
                    <div className='pdetail_t'>
                        <span>
                            <img src={home.peopleDetail && home.peopleDetail.icon ? home.peopleDetail.icon:user} alt="" />
                        </span>

                        <div>
                            <p>解忧人称呼:</p>
                            <p>{home.peopleDetail && home.peopleDetail.name}</p>
                        </div>
                    </div>
                    <div className='pdetail_ct'>
                        <span>介绍:</span>
                        <p>
                            {home.peopleDetail && home.peopleDetail.intro}
                        </p>
                    </div>
                </div>
                <div className='p_detail_btn'>
                    <img src={open} alt="" />
                </div>

            </div >
        )
    }
}
export default PersonDetail